import { LOCAL_STORAGE_AUTHTOKEN } from '@/consts/local-storage'

import NotificationService from '@/services/notification'

import { decodeJwt } from '@/helpers/jwt'
import i18n from '@/helpers/i18n'
import { EventBus } from '@/helpers/event-bus.js'

import Store from '@/stores/store'

const containBusiness = item => item.metadata && item.metadata.isBusiness === true

export default {
  async updateCartUserId() {
    const token = localStorage.getItem(LOCAL_STORAGE_AUTHTOKEN)
    const decoded = decodeJwt(token)
    let userId
    if (decoded) {
      userId = decoded.nameid
    }

    let items = window.Snipcart.store.getState().cart.items
    let i
    for (i = 0; i < items.length; i++) {
      let itm = items[i]
      if (userId) {
        if (!itm.metadata) {
          itm.metadata = {}
        }
        itm.metadata.userId = userId
      } else if (itm.metadata && itm.metadata.userId) {
        delete itm.metadata.userId
      }
      await window.Snipcart.api.cart.items.update(itm)
    }
  },
  addBusinessToCart(businessId, name, silentDuplicate) {
    let cart = window.Snipcart.store.getState().cart.items
    let i
    let exists = false

    for (i = 0; i < cart.items.length; i++) {
      let itm = cart.items[i]
      if (itm.id === businessId) {
        exists = true
        if (!silentDuplicate) {
          NotificationService.showInfo(i18n.t('subscribe-alreadyincart'))
        }
        break
      }
    }

    if (!exists) {
      window.Snipcart.api.cart.items.add({
        id: businessId,
        name: name,
        description: Store.getters.subscribeDescription,
        image: Store.getters.subscribeImage,
        metadata: {
          isBusiness: true
        },
        price: Store.getters.subscribePrice,
        url: Store.getters.businessProductValidationUrl + '&bi=' + businessId,
        quantity: 1,
        maxQuantity: 1,
        shippable: false
      })
    }
  },
  async removeBusinessFromCart() {
    let items = window.Snipcart.store.getState().cart.items
    let i
    for (i = items.length - 1; i >= 0; i--) {
      let itm = items[i]
      if (itm.metadata && itm.metadata.isBusiness) {
        await window.Snipcart.api.cart.items.remove(itm.uniqueId)
      }
    }
  },
  cartConfirmed(cartConfirmResponse) {
    if (cartConfirmResponse.items.items.some(containBusiness)) {
      EventBus.$emit('subscribe-paid')
    }
  }
}
